import { TrashIcon } from '@radix-ui/react-icons'
import { TooltipWrapper } from 'components/TooltipWrapper'
import { useRolodexEdit } from 'features/fde'
import { useKestrel } from 'features/kestrelViewer'
import { KestrelCommands } from 'features/kestrelViewer/types/KestrelCommands'
import React, { FC } from 'react'
import styled from 'styled-components'
import { KVPlaneIntersection, RolodexEntryPatchJson } from 'types'

const StyledButton = styled.button`
  all: unset;
  cursor: pointer;
  padding: 0.25rem;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${({ theme }) => theme.forecast.activeText};

  &:hover {
    background-color: ${({ theme }) => theme.forecast.background3};
  }
`

export const DeletePlaneIntersectionButton: FC<{
  planeIntersectionId: string
}> = ({ planeIntersectionId }) => {
  const {
    sendKVCommand,
    selectedMarkup,
    setSelectedMarkup,
    kestrelModel,
    planeIntersections,
    setPlaneIntersections,
  } = useKestrel()
  const { rolodexPatch } = useRolodexEdit()

  return (
    <TooltipWrapper
      side={'right'}
      offset={5}
      label={'Delete Plane Intersection'}>
      <StyledButton
        onClick={(e) => {
          e.stopPropagation()
          let filteredPlaneIntersections: KVPlaneIntersection[] = []
          if (planeIntersections) {
            filteredPlaneIntersections = planeIntersections.filter(
              (a) => a.id !== planeIntersectionId
            )
          }
          if (sendKVCommand) {
            setPlaneIntersections(filteredPlaneIntersections)
            sendKVCommand({
              command: KestrelCommands.DELETE_PLANE_INTERSECTION,
              planeIntersectionId: planeIntersectionId,
            })
            if (selectedMarkup?.id === planeIntersectionId)
              setSelectedMarkup(undefined)

            // Delete from Rolodex
            if (kestrelModel?.id) {
              const patchData: RolodexEntryPatchJson = {
                id: kestrelModel.id,
                data: {
                  planeIntersections: filteredPlaneIntersections,
                },
              }
              rolodexPatch([patchData])
            }
          }
        }}>
        <TrashIcon width={16} height={16} />
      </StyledButton>
    </TooltipWrapper>
  )
}
